"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSummaryReact = exports.TableSummary = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../store/constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TableSummaryReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TableSummaryReact, _React$Component);
  var _super = _createSuper(TableSummaryReact);
  function TableSummaryReact() {
    var _this;
    (0, _classCallCheck2.default)(this, TableSummaryReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sendFeedback", function () {
      _this.props.fireFeedback();
    });
    return _this;
  }
  (0, _createClass2.default)(TableSummaryReact, [{
    key: "render",
    value: function render() {
      var table = this.props.table;
      var specialtyMap = {
        'Dental/Orthodontics': 'dental',
        'Fertility': 'fertility',
        'Hair Restoration': 'hair restoration',
        'Weight Loss Surgery': 'weight loss'
      };
      var renderTableSummary = function renderTableSummary(tableProp) {
        var nameText = tableProp.searchQuery && tableProp.searchQuery.name ? "named \u201C".concat(tableProp.searchQuery.name, "\u201D") : '';
        var locationText = tableProp.searchQuery && tableProp.searchQuery.location ? "located in \u201C".concat(tableProp.searchQuery.location, "\u201D") : '';
        var specialtyText = tableProp.searchQuery && tableProp.searchQuery.specialty ? specialtyMap[tableProp.searchQuery.specialty] : '';
        var numberOfPractices = tableProp && tableProp.totalResultsFromExactSearch ? tableProp.totalResultsFromExactSearch : tableProp && tableProp.records ? tableProp.records.length : 0;
        var noMatchText = /*#__PURE__*/_react.default.createElement("p", null, "Sorry! We couldn\u2019t find any matches for ", specialtyText, " providers ", /*#__PURE__*/_react.default.createElement("b", null, nameText), " ", /*#__PURE__*/_react.default.createElement("b", null, locationText), ".");
        if (tableProp.resultType === _constants.FUZZY && tableProp.request === _constants.COMPLETE) {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "We couldn\u2019t find any matches for ", specialtyText, " providers ", /*#__PURE__*/_react.default.createElement("b", null, nameText), " ", /*#__PURE__*/_react.default.createElement("b", null, locationText), ". Did you mean one of the practices below?"));
        } else if (tableProp.resultType === _constants.EXACT && (tableProp.request === _constants.COMPLETE || tableProp.request === _constants.MORE_COMPLETE)) {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "We found ", /*#__PURE__*/_react.default.createElement("b", null, numberOfPractices), " practices matching your search."), /*#__PURE__*/_react.default.createElement("p", null, "Can\u2019t find your provider? Try entering more information to narrow down your search."));
        } else if (tableProp.resultType === _constants.NOMATCH && tableProp.request === _constants.COMPLETE) {
          return /*#__PURE__*/_react.default.createElement("div", null, noMatchText);
        } else if (tableProp.resultType === _constants.ERROR) {
          return /*#__PURE__*/_react.default.createElement("p", null, "Sorry! We are unable to process your request at this time. Please try again later.");
        }
        return '';
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-summary"
      }, renderTableSummary(table));
    }
  }]);
  return TableSummaryReact;
}(_react.default.Component);
exports.TableSummaryReact = TableSummaryReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo,
    table: state.table
  };
};
TableSummaryReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  fireFeedback: _propTypes.default.func,
  table: _propTypes.default.object
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var TableSummary = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TableSummaryReact);
exports.TableSummary = TableSummary;
